<script>
	import { push } from 'svelte-spa-router';
	import fetchData from '../api.js';
	import UserStore from '../stores/user';
	import { clearActiveCart } from '../stores/activeCart';

	let email = '';
	let password = '';
	let error = '';
	let busy = false;

	localStorage.setItem('user', '{}');

	async function login() {
		error = '';
		busy = true;
		const res = await fetchData({ action: 'login', email: email.trim(), password });
		busy = false;
		if (res && Number(res.success) === 1 && res.data) {
			const user = {
				data: res.data,
				id: res.user.id,
				agent_name: res.user.name,
				email: res.user.email,
				role: res.user.role,
				must_change_password: Number(res.user.must_change_password) === 1,
				can_returns: Number(res.user.can_returns) === 1,
				company: res.company
			};
			localStorage.setItem('user', JSON.stringify(user));
			UserStore.set(user);
			clearActiveCart();
			push(user.must_change_password ? '/account' : '/agents/products');
		} else if (res === false) {
			error = 'אין חיבור לשרת. בדוק את האינטרנט ונסה שוב.';
		} else {
			error = 'המייל או הסיסמה לא נכונים';
		}
	}
</script>

<div class="wrap">
	<form class="box" on:submit|preventDefault={login}>
		<div class="logo-mark">A</div>
		<h1>כניסה לסוכנים</h1>
		<label>
			<span>מייל</span>
			<input type="email" bind:value={email} autocomplete="username" inputmode="email" dir="ltr" required />
		</label>
		<label>
			<span>סיסמה</span>
			<input type="password" bind:value={password} autocomplete="current-password" dir="ltr" required />
		</label>
		{#if error}<div class="alert-error">{error}</div>{/if}
		<button class="btn-primary" type="submit" disabled={busy}>{busy ? 'נכנס…' : 'כניסה'}</button>
		<p class="muted note">שכחת סיסמה? פנה למנהל המערכת.</p>
	</form>
</div>

<style>
	.wrap { min-height: 100vh; display: grid; place-items: center; padding: 24px; }
	.box {
		width: min(440px, 100%); background: var(--surface); border: 1px solid var(--line); border-radius: 22px;
		padding: 36px 32px; display: flex; flex-direction: column; gap: 16px; box-shadow: var(--shadow);
	}
	.logo-mark { width: 56px; height: 56px; font-size: 26px; margin: 0 auto; }
	h1 { margin: 0 0 6px; text-align: center; font-size: 26px; }
	label { display: flex; flex-direction: column; gap: 6px; font-weight: 500; }
	label span { font-size: 15px; color: var(--ink-2); }
	input {
		height: 54px; border: 1px solid var(--line-strong); border-radius: 12px; padding: 0 14px; font-size: 18px; background: var(--surface);
	}
	input[dir='ltr'] { text-align: left; }
	input:focus { outline: none; border-color: var(--ink); box-shadow: inset 0 0 0 1px var(--ink); }
	.btn-primary { margin-top: 6px; width: 100%; }
	.note { margin: 0; text-align: center; font-size: 14px; }
</style>
